import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { DistrictInChargeAxios } from "api/DistrictInChargeAxios";

import axios from "axios";

export interface ResourceRequest {
  id?: number;
  ResourceRequestName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchResourceRequests = createAsyncThunk(
  "ResourceRequest/fetchResourceRequests",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        // params.append("filters", JSON.stringify(filters));
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // filterField is expected to be either 'created_at' or 'updated_at'
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    const dateKey = `${filterField}_${
                      key === "from_date" ? "from" : "to"
                    }`;
                    params.append(dateKey, String(value));
                  }
                });
              } else {
                // Handle primitive values (string, number)
                if (filterField === "covered") {
                  // If filterValue is "Covered", convert to true
                  // If it's "Not Covered", convert to false
                  console.log(
                    `filterValue: ${filterValue} filterField: ${filterField}`
                  );
                  const booleanValue =
                    filterValue === "covered"
                      ? true
                      : filterValue === "uncovered"
                      ? false
                      : filterValue;
                  params.append(filterField, String(booleanValue));
                } else {
                  params.append(filterField, filterValue);
                }
              }
            }
          }
        );
      }

      //   const response: any = await DistrictInChargeAxios.get(
      //     `/ResourceRequest/?${params.toString()}`
      //   );
      const response: any = await DistrictInChargeAxios.get(
        `/district_resource_request/list/?${params.toString()}`
      );
      // const response: any = await DistrictInChargeAxios.get(`/district/`, {
      //   params: {
      //     page,
      //     page_size: pageSize,
      //     search: search || undefined,
      //     filters: filters ? JSON.stringify(filters) : undefined,
      //   },
      // });

      // response.data;
      return {
        data: response.data.data || [],
        // data: response.data || [],
        rowCount: response.data.count || 0,
        // rowCount: response.count || 0,
      };
    } catch (error: any) {
      throw new Error("Failed to fetch Storage Locations");
    }
  }
);

export const fetchOnlyAllResourceRequests = createAsyncThunk(
  "",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await DistrictInChargeAxios.get("/ResourceRequest");
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch ResourceRequest by ID"
      );
    }
  }
);

export const fetchResourceRequestById = createAsyncThunk(
  "ResourceRequest/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await DistrictInChargeAxios.get(`/ResourceRequest/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch ResourceRequest by ID"
      );
    }
  }
);

export const fetchResourceRequestByDropDown = createAsyncThunk(
  "ResourceRequest/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await DistrictInChargeAxios.get(`/ResourceRequest/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch ResourceRequest list"
      );
    }
  }
);

export const updateResourceRequest = createAsyncThunk(
  "ResourceRequest/updateResourceRequest",
  async ({
    id,
    ResourceRequestData,
  }: {
    id: string;
    ResourceRequestData: any;
  }) => {
    const response: any = await DistrictInChargeAxios.put(
      `/district_storage_location/update/${id}/`,
      ResourceRequestData
    );
    return response;
  }
);

export const updateStatusInResourceRequest = createAsyncThunk(
  "ResourceRequest/updateStatusInResourceRequest",
  async (ResourceRequestData: any, { rejectWithValue }) => {
    const payload = {
      is_active: ResourceRequestData.is_active,
    };
    try {
      //   const response: any = await DistrictInChargeAxios.patch(
      //     `/district_storage_location/status/${ResourceRequestData.id}/`,
      //     payload
      //   );
      const response: any = await DistrictInChargeAxios.patch(
        `/district_storage_location/status/${ResourceRequestData.id}/`,
        payload
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update status");
    }
  }
);

export const addResourceRequest = createAsyncThunk(
  "ResourceRequest/addResourceRequest",
  async (ResourceRequestData: any, { rejectWithValue }) => {
    try {
      const response = await DistrictInChargeAxios.post(
        `/district_resource_request/Create/`,
        ResourceRequestData
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to add ResourceRequest"
      );
    }
  }
);

export const exportResourceRequestCSV = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            Object.entries(filterValue).forEach(([key, value]) => {
              if (value !== undefined && value !== null && value !== "") {
                params.append(key, String(value));
              }
              if (
                (filterValue.from_date || filterValue.to_date) &&
                (filterField === "created_at" || filterField === "updated_at")
              ) {
                if (filterField === "created_at") {
                  filterField = "created";
                } else {
                  filterField = "updated";
                }
                params.append("filter_by", filterField);
              }
            });
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await DistrictInChargeAxios.get(
    `/district_resource_request/list/?${params.toString()}`,
    {
      responseType: "blob",
    }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "ResourceRequest.csv",
  };
};
